import React, { useState, useEffect } from 'react';
import AlertMessage from 'components/AlertMessage';
import { bannerWhatsNewGet } from '../../api';

const WhatsNewBanner = (props) => {
   
    const [message, setMessage] = useState('');

    const writeStorage = (message) => {
        localStorage.setItem('whatsNewAlertMessage', JSON.stringify({message: message}))
    }

    const isClosed = () => {
        writeStorage(message)
    }

    const wasClosed = (message) => {
        const localMessage = JSON.parse(localStorage.getItem('whatsNewAlertMessage'));
        return message==localMessage?.message
    }

    useEffect(() => {
        bannerWhatsNewGet({})
        .then(response => {
            setMessage(response.data.body) // response data type
        }).catch(error => {
            console.log(error)
        })
    }, [message]);

    return (
        <>  
            { !wasClosed(message) && <AlertMessage alertMessage={message} spaces="" isClosed={isClosed} styleClass={props.styleClass} title="What's new"/> }
        </>
    );
}

export default WhatsNewBanner;